import { render, staticRenderFns } from "./NewST.vue?vue&type=template&id=35736c6e&"
import script from "./NewST.vue?vue&type=script&lang=js&"
export * from "./NewST.vue?vue&type=script&lang=js&"
import style0 from "./NewST.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports